import React from "react";
import { useDispatch } from "react-redux";
import Tippy from "@tippy.js/react";
import "tippy.js/dist/tippy.css";
import { useSelector } from "react-redux";
import qMark from "../../images/qMark.png";
import { Container } from "./detailsStyling";
import {
  sendUpdatedDetails,
  setCompanyDefaults,
  updateLeaderInfo,
} from "../../store/entities/project";
import { getGlobalCompanyDefaults } from "../../store/entities/global";
import { generateArray, isNumberKey, months } from "../../helpers";
import dropArrow2 from "../../images/dropArrow2.png";
// onKeyDown={(e) => isNumberKey(e)}

function CompanyRows() {
  const leader = useSelector((state) => state.user.selectedLeader);
  const dispatch = useDispatch();
  const {
    orgSizes,
    orgTypes,
    fundingLevelMin,
    fundingLevelMax,
    fundingLevelInc,
    matchFundingSources,
    years,
  } = useSelector((state) => state.entities.global.data);
  const { companyDefaultsApplied } = useSelector(
    (state) => state.entities.project
  );

  const fundingLevels = generateArray(
    fundingLevelMin,
    fundingLevelMax,
    fundingLevelInc
  );

  const checkedOrgTypes =
    leader === "lead"
      ? orgTypes.filter((type) => type !== "Academic")
      : orgTypes;

  function onchangeHandler(e) {
    const key = e.target.name;
    let value = e.target.value;
    // console.log(value);
    value = value.slice(0, 50);
    dispatch(updateLeaderInfo({ leader, key, value }));
    if (key === "organisationType" && value === "Academic")
      dispatch(updateLeaderInfo({ leader, key: "fundingLevel", value: 100 }));
  }

  function sendChanges() {
    dispatch(sendUpdatedDetails());
  }

  const {
    companyName,
    companyAcronym,
    organisationType,
    organisationSize,
    postcode,
    turnover,
    lastFinancialYear,
    lastFinancialMonth,
    lawyer,
    bankHolidays,
    annualLeave,
    numEmployees,
    partnerFunding,
    fundingLevel,
    matchFundingSource,
    investorName,
  } = useSelector((state) => state.entities.project.data[leader]);

  const defaults = useSelector(getGlobalCompanyDefaults);
  function applyDefaults() {
    dispatch(setCompanyDefaults({ defaults, leader }));
  }

  const data = {
    maxHeight: "550px",
  };

  return (
    <Container data={data}>
      <div className="rows company">
        <div className="bottomLeftCorner">
          {companyDefaultsApplied ? null : (
            <button onClick={applyDefaults}>
              <h3>Apply defaults</h3>
            </button>
          )}
        </div>

        <div className="row column">
          <div className="title">
            <p>Full Company Name</p>
          </div>
          <input
            type="text"
            value={companyName}
            className="field"
            name="companyName"
            onChange={onchangeHandler}
            onBlur={sendChanges}
          />
        </div>

        <div className="row column">
          <div className="title">
            <p>Company Nickname</p>
            <Tippy content="Provide a short name for use across this website">
              <div className="info">
                <img src={qMark} alt="info" />
              </div>
            </Tippy>
          </div>
          <input
            type="text"
            value={companyAcronym}
            className="field"
            name="companyAcronym"
            onChange={onchangeHandler}
            onBlur={sendChanges}
          />
        </div>

        <div className="row column">
          <div className="title">
            <p>Organisation Type</p>
          </div>
          <select
            value={organisationType}
            className="field"
            name="organisationType"
            onChange={onchangeHandler}
            onBlur={sendChanges}
          >
            <option hidden>select</option>
            {checkedOrgTypes.map((value, index) => {
              return (
                <option key={index} value={value}>
                  {value}
                </option>
              );
            })}
          </select>
          <div className="dropdown">
            <img src={dropArrow2} alt="option" />
          </div>
        </div>

        <div className="row column">
          <div className="title">
            <p>Organisation Size</p>
          </div>
          <select
            value={organisationSize}
            className="field"
            name="organisationSize"
            onChange={onchangeHandler}
            onBlur={sendChanges}
          >
            <option hidden>select</option>
            {orgSizes.map((value, index) => {
              return (
                <option key={index} value={value}>
                  {value}
                </option>
              );
            })}
          </select>
          <div className="dropdown">
            <img src={dropArrow2} alt="option" />
          </div>
        </div>

        <div className="row column">
          <div className="title">
            <p>Postcode</p>
            <Tippy content="Postcode for Project Work">
              <div className="info">
                <img src={qMark} alt="info" />
              </div>
            </Tippy>
          </div>
          <input
            type="text"
            value={postcode}
            className="field"
            name="postcode"
            onChange={onchangeHandler}
            onBlur={sendChanges}
          />
        </div>

        <div className="row column">
          <div className="title">
            <p>Turnover</p>
            <Tippy content="Turnover last financial year">
              <div className="info">
                <img src={qMark} alt="info" />
              </div>
            </Tippy>
          </div>
          <input
            type="text"
            value={turnover}
            className="field"
            name="turnover"
            onKeyDown={(e) => isNumberKey(e)}
            onChange={onchangeHandler}
            onBlur={sendChanges}
          />
        </div>

        <div className="row column">
          <div className="title">
            <p>Last Financial Year</p>
            {/* <Tippy content="Check IUK competition website for guidance on project lengths">
              <div className="info">
                <img src={qMark} alt="info" />
              </div>
            </Tippy> */}
          </div>
          <div className="projectStart">
            {/* <Tippy placement="top-start" content="Month project starts"> */}
            <select
              className="field month"
              name="lastFinancialMonth"
              value={lastFinancialMonth}
              onChange={onchangeHandler}
              onBlur={sendChanges}
            >
              <option hidden>select</option>
              {months.map((month, index) => {
                return (
                  <option key={index} value={month}>
                    {month}
                  </option>
                );
              })}
            </select>
            {/* </Tippy> */}
            {/* <Tippy content="Year project starts"> */}
            <select
              className="field year"
              name="lastFinancialYear"
              value={lastFinancialYear}
              onChange={onchangeHandler}
              onBlur={sendChanges}
            >
              <option hidden>select</option>
              {years.map((year, index) => {
                return (
                  <option key={index} value={year}>
                    {year}
                  </option>
                );
              })}
            </select>
            {/* </Tippy> */}
          </div>
        </div>

        <div className="row column">
          <div className="title">
            <p>IP Lawyer Name</p>
          </div>
          <input
            type="text"
            value={lawyer}
            className="field"
            name="lawyer"
            onChange={onchangeHandler}
            onBlur={sendChanges}
          />
        </div>

        <div className="row column">
          <div className="title">
            <p>Bank Holidays</p>
          </div>
          <input
            type="text"
            value={bankHolidays}
            className="field"
            onKeyDown={(e) => isNumberKey(e)}
            name="bankHolidays"
            onChange={onchangeHandler}
            onBlur={sendChanges}
          />
        </div>

        <div className="row column">
          <div className="title">
            <p>Annual Leave Entitlement</p>
          </div>
          <input
            type="text"
            value={annualLeave}
            className="field"
            onKeyDown={(e) => isNumberKey(e)}
            name="annualLeave"
            onChange={onchangeHandler}
            onBlur={sendChanges}
          />
        </div>

        <div className="row column">
          <div className="title">
            <p>Current Number of Employees</p>
          </div>
          <input
            type="text"
            value={numEmployees}
            className="field"
            name="numEmployees"
            onKeyDown={(e) => isNumberKey(e)}
            onChange={onchangeHandler}
            onBlur={sendChanges}
          />
        </div>
        {/* Funding Level –  */}
        {/* Match Funding Source –  */}

        <div className="row column">
          <div className="title">
            <p>Partner will Receive Grant Funding?</p>
          </div>
          <select
            type="text"
            value={partnerFunding}
            className="field"
            name="partnerFunding"
            onChange={onchangeHandler}
            onBlur={sendChanges}
            // selected='No'
          >
            <option hidden>select</option>
            <option value="No">No</option>
            <option value="Yes">Yes</option>
          </select>
          <div className="dropdown">
            <img src={dropArrow2} alt="option" />
          </div>
        </div>

        {partnerFunding === "Yes" ? (
          <div className="row column">
            <div className="title">
              <p>Funding Level (%)</p>
              <Tippy content="The percentage of the project cost the funder will provide. See competition guidance for details">
                <div className="info">
                  <img src={qMark} alt="info" />
                </div>
              </Tippy>
            </div>
            <select
              type="text"
              value={fundingLevel}
              className="field"
              name="fundingLevel"
              onChange={onchangeHandler}
              onBlur={sendChanges}
            >
              <option hidden>select</option>
              {fundingLevels.map((value, index) => {
                return (
                  <option key={index} value={value}>
                    {value}
                  </option>
                );
              })}
            </select>
            <div className="dropdown">
              <img src={dropArrow2} alt="option" />
            </div>
          </div>
        ) : null}

        <div className="row column">
          <div className="title">
            <p>Match Funding Source</p>
          </div>
          <select
            type="text"
            value={matchFundingSource}
            className="field"
            name="matchFundingSource"
            onChange={onchangeHandler}
            onBlur={sendChanges}
          >
            <option hidden>select</option>
            {matchFundingSources.map((value, index) => {
              return (
                <option key={index} value={value}>
                  {value}
                </option>
              );
            })}
          </select>
          <div className="dropdown">
            <img src={dropArrow2} alt="option" />
          </div>
        </div>

        {matchFundingSource === "Company Funds" ? null : (
          <div className="row column">
            <div className="title">
              <p>Investor Name</p>
              <Tippy content="The source of the match funding provided to the project by the project partner">
                <div className="info">
                  <img src={qMark} alt="info" />
                </div>
              </Tippy>
            </div>
            <input
              type="text"
              value={investorName}
              className="field"
              name="investorName"
              onChange={onchangeHandler}
              onBlur={sendChanges}
            />
          </div>
        )}
      </div>
    </Container>
  );
}
export default CompanyRows;
